export const abuse = {
  title: 'Segnala Abuso',
  subtitle: 'Prendiamo sul serio le segnalazioni di abuso e investighiamo accuratamente ogni caso. Segui la procedura qui sotto per segnalare un abuso.',
  howWeHandle: 'Come Gestiamo le Segnalazioni di Abuso',
  sendReport: 'Invia la tua segnalazione a',
  legalNotice: 'Per gli enti legali, si prega di includere anche',
  steps: {
    reception: {
      title: 'Ricezione Segnalazione',
      description: 'Riceviamo la tua segnalazione e assegniamo un numero di caso univoco per il tracciamento'
    },
    review: {
      title: 'Revisione Iniziale',
      description: 'Il nostro team esamina la segnalazione e conferma la ricezione entro 24 ore'
    },
    investigation: {
      title: 'Investigazione',
      description: 'Investighiamo accuratamente il problema segnalato e verifichiamo tutte le prove fornite'
    },
    resolution: {
      title: 'Risoluzione',
      description: 'Prendiamo le azioni appropriate e forniamo una risposta dettagliata'
    }
  },
  requiredInfo: {
    title: 'Cosa Includere nella Segnalazione',
    subtitle: 'Informazioni Richieste',
    items: [
      'Descrizione dettagliata dell\'abuso',
      'Data e ora dell\'incidente',
      'Indirizzi IP coinvolti',
      'Eventuali log o prove pertinenti',
      'I tuoi contatti'
    ]
  },
  commitment: {
    title: 'Il Nostro Impegno',
    items: [
      'Risposta iniziale rapida entro 24 ore',
      'Investigazione approfondita di tutte le segnalazioni',
      'Aggiornamenti regolari sullo stato del caso',
      'Comunicazione trasparente',
      'Risoluzione equa ed efficace'
    ]
  }
};